import { MouseEvent } from 'react'
import { iconChecked, iconUnchecked } from 'assets/Icons'
import { Icon } from 'assets/index'
import Card from './style'

interface ISelectCard {
  checked?: boolean
  icon: any
  value: string
  onClick: (_e: MouseEvent<HTMLElement>) => void
}

export default function ActionCard(props: ISelectCard) {
  const { value, icon, checked } = props

  return (
    <Card {...props}>
      <img
        className="sc-selected-icon"
        src={checked ? iconChecked : iconUnchecked}
        alt="select icon"
      />
      <div className="sc-icon-content">
        <img className="sc-icon" src={Icon(icon)} alt="card icon" />
      </div>
      <div>
        <span className="sc-title">{value}</span>
      </div>
    </Card>
  )
}
